import React from "react";
import { useTranslation } from "react-i18next";
import ab1 from '../assets/about-sec-img/ab1.svg';
import ab2 from '../assets/about-sec-img/ab2.svg';
import ab3 from '../assets/about-sec-img/ab3.svg';

export const AboutSection = () => {
  const { t, i18n } = useTranslation();

  // Define inline styles for text alignment and direction based on language
  const dirComp = {
    textAlign: i18n.language === "ar" ? "right" : "left",
    direction: i18n.language === "ar" ? "rtl" : "ltr",
  };

  const teamData = [
    {
      id: 1,
      img: ab1,
      heading: t("AboutComp.subheading1"),
      description: t("AboutComp.subDesc1"),
    },
    {
      id: 2,
      img:ab2,
      heading: t("AboutComp.subheading2"),
      description: t("AboutComp.subDesc2"),
    },
    {
      id: 3,
      img: ab3,
      heading: t("AboutComp.subheading3"),
      description: t("AboutComp.subDesc3"),
    },
  ];

  return (
    <div className="py-8 font-sora" style={{ fontFamily: "sora" }}>
      <div className="text-center flex flex-col items-center justify-center">
        <h1
          className="text-[#222157] font-bold text-2xl md:text-4xl my-2"
          style={dirComp}
        >
          {t("AboutComp.aboutTitle")}
        </h1>
        <p
          className="text-[#222157] leading-6 2xl:text-[1.2rem] text-center font-medium  mx-[3rem] my-6 2xl:my-7 mt-[1.6rem] w-[65%]"
          // style={dirComp}
        >
          {t("AboutComp.aboutDescription")}
        </p>
      </div>
      <div className="flex justify-center flex-wrap gap-4">
        {teamData.map((item) => (
          <div key={item.id} className="relative flex flex-col items-center">
            <img
              src={item.img}
              alt={`teamImg-${item.id}`}
              className="w-full object-cover rounded-[1.25rem]"
            />
            <div
              className={`flex flex-col mb-[2.5rem]  absolute bottom-[1rem] text-white ${dirComp} `}
            >
              <p className="text-xl font-bold mx-4 px-2" style={dirComp}>
                {item.heading}
              </p>
              <p className=" mt-2 text-[0.92rem] font-medium mx-4 px-2">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
